import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconChevronDown: React.FC<IconProps> = ({
  size = 24,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M5 9l7 7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default IconChevronDown;
